<template>
  <span class="icon icon--down">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.98 5.34">
      <title>arrow</title>
      <path d="M7.79,1.33,4.67,5.05A.84.84,0,0,1,4,5.34a.82.82,0,0,1-.68-.29L.19,1.33a.81.81,0,1,1,1.24-1L4,3.34l2.56-3A.81.81,0,0,1,7.69.19.82.82,0,0,1,7.79,1.33Z"/>
    </svg>
  </span>
</template>

<script>
  export default {
    name: "Down"
  }
</script>
